var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"font-weight-medium",attrs:{"absolute":"","dark":"","app":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('p',{staticClass:"copyright"},[_c('strong',[_vm._v("© Copyright "+_vm._s(new Date().getFullYear())+" ISLAND STATE MUSIC")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }